<div class="loadingOverlay" *ngIf="loadingStatus$ | async">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
    <img class="center-icon" src="assets/images/gov-mini-icon.svg"/>
</div>